import { useEffect, useState } from 'react'

import { loadReleaseVersion } from '../release/releaseVersion'

/** A small deployment marker in the bottom of the signed-in Market sidebar. */
export const ReleaseVersion = () => {
  const [version, setVersion] = useState<string | null>(null)

  useEffect(() => {
    let active = true
    void loadReleaseVersion().then((value) => {
      if (active) setVersion(value)
    })
    return () => {
      active = false
    }
  }, [])

  if (!version) return null

  return (
    <span className="market-shell__release-version" title={`Версия Провизиум ${version}`}>
      {version}
    </span>
  )
}
